import {EXTENSION_ID} from 'src/chat-extension/constants';


export const sendMessageToExtension = (type: string, payload: unknown) => {
  try {
    const chrome = window.chrome;
    if (!chrome || !chrome.runtime) {
      return;
    }
    chrome.runtime.sendMessage(EXTENSION_ID, {type, payload});
  } catch (error: any) {
    console.error('Error sending message to extension:', error);
  }
};
